import React, { useState } from "react";
import { createUseStyles } from "react-jss";
import ReactInputRange from "react-input-range";
import { sendMetriks } from "Services/sendMetriks";

const useStyles = createUseStyles((theme) => ({
	box: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		width: "239px",
		height: "90px",
		border: `solid 1px ${theme.palette.colors.lightGrayishViolet}`,
		borderRadius: "10px",
	},
	picker: {
		margin: "15px 0 20px",
		"& .input-range__track--background": {
			backgroundColor: theme.palette.colors.lightGrayishViolet,
			width: "195px",
		},
		"& .input-range__track": {
			height: "1px",
			position: "relative",
		},
		"& .input-range__track--active": {
			backgroundColor: theme.palette.colors.purplishBlue,
		},
		"& .input-range__label": {
			display: "none",
		},
		"& .input-range__slider": {
			width: "20px",
			height: "20px",
			backgroundColor: theme.palette.colors.white,
			boxShadow: "0 2px 3px 0 rgba(0, 0, 0, 0.1)",
			border: `solid 1px ${theme.palette.colors.lightGrayishViolet}`,
			borderRadius: "50%",
			position: "absolute",
			left: "-9px",
			top: "-10px",
		},
	},
	text: {
		fontFamily: theme.fonts.medium,
		fontSize: "16px",
		color: theme.palette.colors.purplishBlue,
		backgroundColor: theme.palette.colors.white,
	},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {},
	[`@media (max-width: ${theme.media.sm})`]: {},
}));

function RangePickerAntifilter(props) {
	let {
		setStateRange,
		arrRange,
		setStateValue,
		setSwitchTariff,
		switchType,
		valueCur,
		description,
	} = props;
	const classes = useStyles();

	const [value, setState] = useState(Number(arrRange.indexOf(valueCur) + 1));

	return (
		<div className={classes.box}>
			<div className={classes.text} onClick={() => setStateRange(false)}>
				{arrRange[value]} {description}
			</div>
			<div className={classes.picker}>
				<ReactInputRange
					disabled={arrRange.length - 1 === 0}
					minValue={0}
					maxValue={arrRange.length - 1}
					value={value}
					onChangeComplete={(value) => {
						sendMetriks("CHANGE_ANTIFILTR");
						setStateValue(arrRange[value]);
						setSwitchTariff(switchType);
						setStateRange(false);
					}}
					onChange={(value) => {
						setState(value);
					}}
					step={1}
				/>
			</div>
		</div>
	);
}

export default RangePickerAntifilter;
